import classNames from "classnames";
import React, { useState } from "react";
import Select, { SingleValue } from "react-select";

import { SortItem } from "@components/Search/SearchResults/StateComponents/Sort/sort.container";

import "./sort.scss";

type SortComponentProps = {
    items: Array<SortItem>;
    refinedItem?: SortItem;
    refine: (value: string) => void;
    className?: string;
};

const SortComponent = ({
    items,
    refinedItem,
    refine,
    className,
}: SortComponentProps) => {
    const [optimisticValue, setOptimisticValue] = useState<
        SortItem | undefined
    >(refinedItem);

    const handleOnSelectChange = (option: SingleValue<SortItem>) => {
        if (!option) return;

        setOptimisticValue(option);
        refine(option.value);
    };

    return (
        <Select
            className={classNames("sort", className)}
            openMenuOnFocus={true}
            classNamePrefix="select-box"
            options={items}
            isSearchable={false}
            blurInputOnSelect={true}
            value={optimisticValue}
            onChange={handleOnSelectChange}
        />
    );
};

export { SortComponent };
